export var ProvisionType;
(function (ProvisionType) {
    ProvisionType["UNKNOWN"] = "UNKNOWN";
    /** MetaSite with HTML App (Template) installed in draft mode */
    ProvisionType["HTML_DRAFT"] = "HTML_DRAFT";
    /** Education */
    ProvisionType["EDUCATION"] = "EDUCATION";
    /** Dashboard First MetaSite */
    ProvisionType["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    /** Dayful MetaSite */
    ProvisionType["DAYFUL"] = "DAYFUL";
    /** Headless MetaSite */
    ProvisionType["HEADLESS"] = "HEADLESS";
    /** Dashboard First for existing MetaSite */
    ProvisionType["DASHBOARD_FIRST_SETUP_EXISTING"] = "DASHBOARD_FIRST_SETUP_EXISTING";
    /** Branded First MetaSite */
    ProvisionType["BRANDED_FIRST"] = "BRANDED_FIRST";
    /** Demo MetaSite */
    ProvisionType["DEMO"] = "DEMO";
})(ProvisionType || (ProvisionType = {}));
export var SiteType;
(function (SiteType) {
    SiteType["UNKNOWN"] = "UNKNOWN";
    SiteType["ANYWHERE"] = "ANYWHERE";
    SiteType["DASHBOARD_FIRST"] = "DASHBOARD_FIRST";
    SiteType["HEADLESS"] = "HEADLESS";
    SiteType["BRANDED_FIRST"] = "BRANDED_FIRST";
})(SiteType || (SiteType = {}));
/** Where the extra text should be displayed: before, after or instead of the actual address. */
export var PlacementType;
(function (PlacementType) {
    PlacementType["BEFORE"] = "BEFORE";
    PlacementType["AFTER"] = "AFTER";
    PlacementType["REPLACE"] = "REPLACE";
})(PlacementType || (PlacementType = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map